import React, { Component } from 'react';
import Select from 'react-select';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import Check from '@fortawesome/fontawesome-free-solid/faCheck'
import { selectors } from '../sagas/keg_size_options';
import { selectors as productOptionSelectors } from '../sagas/product_options'
import { selectors as reservationSelectors } from '../sagas/reservation'
import { actions } from '../sagas/keg_size_options';
import { actions as kegSizeActions} from '../sagas/keg_sizes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectors as kegSizeSelectors } from '../sagas/keg_sizes'
import KegOption from './KegOption'
import _ from 'lodash'
import moment from 'moment'

class KegSizeOptions extends Component {
  kegSizeLabels = () => {
    return {
      'mini_keg': 'Mini Keg (10.6 Pints)',
      'cornelius_keg': 'Cornelius Keg (40 Pints)',
      'sixth_barrel': '1/6th Barrel (42 Pints)',
      'quarter_barrel': 'Quarter Barrel (62 Pints)',
      'slim_quarter': 'Slim Quarter (62 Pints)',
      'half_barrel': '1/2 Barrel (124 Pints)',
      'rubber_barrel': 'Rubber Barrel (62 Pints)',
      'beveled_barrel': 'Beveled Barrel (62 Pints)',
      'fifty_liter': '50 Liter (105 Pints)',
      'thirty_liter': '30 Liter (63 Pints)'
    }
  }


  kegSizeBySelectedType = (productNameToFind) => {
  //TODO: Fix this nonsense, please refactor this!
    let options = []
    let inventoryType = ''
    let products = this.findProductsByName(productNameToFind)

    products.forEach(product => {
      let checkedInDate = moment().add(( ( this.props.waitForReservations || 0 ) + ( this.props.checkedInDateLimit || 0 ) ), 'days').endOf('day')

      let selectedDate = this.props.pick_up_date.startOf('day')

      if (checkedInDate > selectedDate) {
        inventoryType = 'available'
      } else {
        inventoryType = 'future'
      }

      let kegSizes = []
      kegSizes.push(this.props.kegSize)

      let availableInventory = product
        && product.attributes
        && product.attributes.availableInventoryCount

      let alwaysOnInventory = product
        && product.attributes
        && product.attributes.alwaysOnInventory

      let alwaysOnQuantity = product
        && product.attributes
        && product.attributes.alwaysOnQuantity

      let kegPrices = product
        && product.attributes
        && product.attributes.prices

      let futureInventoryCount = product
        && product.attributes
        && product.attributes.futureInventoryCount

      let productName = product
        && product.attributes
        && product.attributes.name

      let kegSizeCounts = {}

      kegSizes && availableInventory && alwaysOnInventory && alwaysOnQuantity &&
      kegSizes.forEach((kegSize, index) => {
        let key = kegSize && kegSize['value'] && kegSize['value']['size']
        let kegSizeId = kegSize && kegSize['value'] && kegSize['value']['id']

        kegSizeCounts[key] = 0

        if ( inventoryType == 'available' ) {
          // Available Inventory
          kegSizeCounts[key] = (kegSizeCounts[key] || 0) + (parseInt(availableInventory[_.camelCase(key)]) || 0)
          kegSizeCounts[key] = (kegSizeCounts[key] || 0) - (this.selectedInventory(product.id, kegSizeId, inventoryType, index) || 0)
        } else {
          // Stocked Inventory
          kegSizeCounts[key] = (kegSizeCounts[key] || 0) + (parseInt(futureInventoryCount[_.camelCase(key)]) || 0)
          kegSizeCounts[key] = (kegSizeCounts[key] || 0) - (this.selectedInventory(product.id, kegSizeId, inventoryType, index) || 0)
        }

        // Always on Inventory
        if ( alwaysOnInventory.includes(key) ) {
          kegSizeCounts[key] = (kegSizeCounts[key] || 0) + (parseInt(alwaysOnQuantity[_.camelCase(key)]) || 0)
        }

        kegSizeCounts && kegSizeCounts[key] > 0 &&
          options.push(
            {
              value: { 'type': 'keg_size', 'id': product.id, 'inventory_type': inventoryType, 'keg_size_id': kegSizeId, 'index': index },
              label: `${productName} $${kegPrices[_.camelCase(key)]}`
            }
          )
        })
    })

    return options
  }

  selectedInventory = (product_id, keg_size_id, inventory_type, index) => {
    let number = 0
    Object.keys(this.props.selectedKegSizes).map( keg_number => {
      let matched_products = []
      if (keg_number == this.props.kegNumber) {
        number = (number || 0)
      } else {
        let keg_size = this.props.selectedKegSizes[keg_number]


        let selected_product_id = keg_size
          && keg_size.value
          && keg_size.value.id

        let selected_keg_size_id = keg_size
          && keg_size.value
          && keg_size.value.keg_size_id

        let keg_size_inventory_type = keg_size
          && keg_size.value
          && keg_size.value.inventory_type

        let keg_size_index = keg_size
          && keg_size.value
          && keg_size.value.index

        if ( selected_keg_size_id === keg_size_id && selected_product_id === product_id && keg_size_inventory_type === inventory_type && keg_size_index ===  index) {
          matched_products.push(keg_size)
        }
        number = (number || 0) + (matched_products.length || 0)
      }
    })
    return number
  }

  kegSizes = () => {
    let kegSizes = this.props.publicInfo && this.props.publicInfo.attributes && this.props.publicInfo.attributes.selectedKegSizes
    let options = []
    kegSizes.forEach(kegSize => {
      options.push(
        {
          value: { 'type': 'keg_size', 'id': kegSize['id'] },
          label: this.kegSizeLabels()[kegSize['size']]
        }
      )
    })
    return options
  }

  kegSizeOptions = () => {
    let productOptions = {}
    this.validProductNames(this.selectedSize()) && this.validProductNames(this.selectedSize()).forEach(name => {
      productOptions[name] = this.kegSizeBySelectedType(name)
    })
    return productOptions
  }

  totalKegSizeOptions = () => {
    let total = 0
    Object.keys(this.kegSizeOptions()).map(product_name => {
      total = total + this.kegSizeOptions()[product_name].length
    })
    return total
  }

  pluralizedKegSizes = () => {
    return {
      'mini_keg': 'Mini Kegs',
      'cornelius_keg': 'Cornelius Kegs',
      'sixth_barrel': '1/6th Barrels',
      'quarter_barrel': 'Quarter Barrels',
      'slim_quarter': 'Slim Quarters',
      'half_barrel': '1/2 Barrels',
      'rubber_barrel': 'Rubber Barrels',
      'beveled_barrel': 'Beveled Barrels',
      'fifty_liter': '50 Liters',
      'thirty_liter': '30 Liters'
    }
  }

  validProductNames = (size) => {
    if (!this.props.products) { return [] }

    let productNames = this.props.products.map(product => {
      return product
        && product.attributes
        && product.attributes.prices
        && product.attributes.prices[_.camelCase(size)]
        && product.attributes.name
    })

    const filteredNames = productNames.filter(name => {
      return name !== undefined && name !== null
    })

    const names = new Set(filteredNames)
    return Array.from(names)
  }

  findProductsByName = (name) => {
    return this.props.products.filter(product => {
      return product.attributes.name === name
    })
  }

  selectedSize = () => {
    return this.props.kegSize && this.props.kegSize.value && this.props.kegSize.value.size
  }

  render () {
    return (this.props.kegSize === undefined || Object.keys(this.props.kegSize || {}).length === 0) ? null : this.totalKegSizeOptions() === 0 ?
        (
      <div style={{ marginTop: 15, padding: 5, width: 315, borderStyle: 'solid', borderColor: '#d9d9d9', borderWidth: 1, borderRadius: 2, backgroundColor: '#FDBF20' }}>
        No {this.pluralizedKegSizes()[this.selectedSize()] || 'kegs'} available - Try changing the pick up date or keg size
      </div>
        )
      : (
      <div key={this.props.kegNumber} style={{ width: 315, marginTop: 15, borderStyle: 'solid', borderColor: '#d9d9d9', borderWidth: 1, borderRadius: 2 }}>
        { this.validProductNames(this.selectedSize()) && this.validProductNames(this.selectedSize()).map(name => {
            let options = this.kegSizeOptions()[name]
            return options && options.map((option, index) => {
              return <KegOption
                key={`kegoption - ${option.value.id} - ${index}`}
                index={index}
                selectKeg={ this.props.handleProduct }
                selectedKeg={ this.props.selectedProduct }
                kegSize={ this.props.kegSize }
                kegNumber={ this.props.kegNumber }
                option={option}
                unselectKeg={ this.props.unselectProduct }
              />
            })
          })
        }
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

const mapStateToProps = (store, ownProps) => ({
  keg_size_options: selectors.keg_size_options(store, ownProps.kegNumber),
  products: productOptionSelectors.product(store, ownProps.kegNumber),
  pick_up_date: reservationSelectors.pick_up_date(store),
  publicInfo: reservationSelectors.publicInfo(store),
  kegSize: reservationSelectors.selected_keg_size(store, ownProps.kegNumber),
  selectedProduct: reservationSelectors.selected_product(store, ownProps.kegNumber),
  selectedKegSizes: reservationSelectors.selectedKegSizes(store)
})

export default (connect(
  mapStateToProps, mapDispatchToProps)(KegSizeOptions));



// WEBPACK FOOTER //
// ./src/Reservations/KegSizeOptions.jsx